var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page_title" },
        [
          _c("custom-breadcrumb", {
            attrs: {
              suffix: "BatchOrder # " + this.dataInfo.batchInfoDetail.uid,
              dsOrder: _vm.dsOrder
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "order" },
        [
          _c("el-card", { attrs: { shadow: "none" } }, [
            _c("div", { staticClass: "order-header" }, [
              _c("div", { staticClass: "order-header-item" }, [
                _c("span", { staticClass: "gray" }, [_vm._v("Order Total")]),
                _vm._v(" "),
                _vm.dataInfo.batchInfoDetail.payAmount
                  ? _c("span", [
                      _vm._v(
                        "$" + _vm._s(_vm.dataInfo.batchInfoDetail.payAmount)
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "border" }),
              _vm._v(" "),
              _c("div", { staticClass: "order-header-item" }, [
                _c("span", { staticClass: "gray" }, [_vm._v("Order Date")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.dataInfo.batchInfoDetail.dateStr))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "border" }),
              _vm._v(" "),
              _c("div", { staticClass: "order-header-item" }, [
                _c("span", { staticClass: "gray" }, [_vm._v("Order Status")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.dataInfo.batchInfoDetail.batchStatusEnName))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "border" }),
              _vm._v(" "),
              _c("div", { staticClass: "order-header-item address" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.dataInfo.batchInfoDetail.name) +
                      " " +
                      _vm._s(_vm.dataInfo.batchInfoDetail.lastname)
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.dataInfo.batchInfoDetail.address))
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.dataInfo.batchInfoDetail.city) +
                      ", " +
                      _vm._s(_vm.dataInfo.batchInfoDetail.province) +
                      ", " +
                      _vm._s(_vm.dataInfo.batchInfoDetail.countryName) +
                      "  " +
                      _vm._s(_vm.dataInfo.batchInfoDetail.postCode)
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.dataInfo.batchInfoDetail.areaCode) +
                      _vm._s(_vm.dataInfo.batchInfoDetail.phone)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "border" }),
              _vm._v(" "),
              _c("div", { staticClass: "order-header-item" }, [
                _c("span", { staticClass: "gray" }, [_vm._v("Customer")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.dataInfo.batchInfoDetail.name +
                        " " +
                        _vm.dataInfo.batchInfoDetail.lastname
                    )
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.dataInfo.batchInfoOrderList, function(brand) {
            return _c(
              "el-card",
              {
                key: brand.id,
                staticClass: "order-content",
                staticStyle: { "margin-top": "20px" },
                attrs: { shadow: "none" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "order-content-header",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [
                    _c("span", { staticClass: "bold" }, [
                      _vm._v(_vm._s(brand.tsStoreOrderInfo.brandName))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(brand.orderDetailList, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "order-content-item" },
                    [
                      _c("el-image", {
                        staticClass: "img",
                        attrs: { src: item.skuImg, fit: "fill" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "item-con" }, [
                        _c("span", { staticClass: "bold" }, [
                          _vm._v(_vm._s(item.skuName))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "padding-top": "4px" } }, [
                          _vm._v(" " + _vm._s(item.skuParams)),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#999999",
                                "margin-left": "20px"
                              }
                            },
                            [_vm._v(_vm._s(item.vdSku))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "item-bottom" }, [
                          _c("div", { staticClass: "item-bottom-item" }, [
                            _c("span", [_vm._v("Items")]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.qty))])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-bottom-item" }, [
                            _c("span", [_vm._v("Wholesale Price")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "$" + _vm._s(Number(item.price).toFixed(2))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-bottom-item" }, [
                            _c("span", [_vm._v("Total")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "$" + _vm._s(Number(item.total).toFixed(2))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "item-bottom-item" }, [
                            _c("span", [_vm._v("Status")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$tool.valueToLabel(
                                    item.orderStatus,
                                    _vm.orderStatusOptions
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                })
              ],
              2
            )
          }),
          _vm._v(" "),
          _c("div", { staticClass: "order-bottom" }, [
            _c("div", [
              _c("span", { staticClass: "bold" }, [_vm._v("Payment method")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.dataInfo.batchInfoDetail.paymethodEnName))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bottom-right" },
              [
                _c("span", { staticClass: "bold" }, [_vm._v("Order Summary")]),
                _vm._v(" "),
                _vm._l(_vm.dataInfo.batchInfoOrderList, function(order, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "bottom-right-block" },
                    [
                      _c("div", { staticClass: "item" }, [
                        _c("span", [
                          _vm._v(_vm._s(order.tsStoreOrderInfo.brandName))
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "$" + _vm._s(order.tsStoreOrderInfo.totalPrice || 0)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      order.tsStoreOrderInfo.orderDiscounted &&
                      order.tsStoreOrderInfo.orderDiscounted > 0
                        ? _c("div", { staticClass: "item orange" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(order.tsStoreOrderInfo.brandName) +
                                  " Discount"
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n              -$" +
                                  _vm._s(
                                    order.tsStoreOrderInfo.orderDiscounted
                                  ) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item bold",
                    staticStyle: { "margin-top": "5px" }
                  },
                  [
                    _c("span", [_vm._v("Subtotal")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "$" +
                          _vm._s(Number(_vm.orderTotal["subTotal"]).toFixed(2))
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "bottom-right-block" }, [
                  _c("div", { staticClass: "item" }, [
                    _c("span", [_vm._v("Shipping")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "$" +
                          _vm._s(Number(_vm.orderTotal["shipping"]).toFixed(2))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.orderTotal["shippingDisc"] &&
                  Number(_vm.orderTotal["shippingDisc"]) > 0
                    ? _c("div", { staticClass: "item orange" }, [
                        _c("span", [_vm._v("Shipping Discount(By Brand)")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "-$" +
                              _vm._s(
                                Number(_vm.orderTotal["shippingDisc"]).toFixed(
                                  2
                                )
                              )
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item bold",
                    staticStyle: { "margin-top": "5px" }
                  },
                  [
                    _c("span", [_vm._v("Order Total")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "$" +
                          _vm._s(
                            Number(
                              _vm.dataInfo["batchInfoDetail"]["payAmount"]
                            ).toFixed(2)
                          )
                      )
                    ])
                  ]
                )
              ],
              2
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("Address", {
        ref: "address",
        attrs: { "address-message": _vm.addressMessage, type: "ordeDetail" }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "viewer",
              rawName: "v-viewer",
              value: { movable: false },
              expression: "{movable: false}"
            }
          ],
          staticClass: "images"
        },
        _vm._l(_vm.images, function(src) {
          return _c("img", { key: src, attrs: { src: src } })
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a9e7737", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a9e7737","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wholesale/procurement-orders-detail.vue
// module id = anlx
// module chunks = 2